import global from '@/assets/js/global'

function monitor(res) {
    if(undefined===res.data) eval(res.event+'()')
    else eval(`transfer(res)`)
}

function transfer(res){
    global.response = res
}

function bind() {
    console.log(`bind`)
    global.isBind = true
}

function ping(res) {
    console.log(`ping`)
    global.response = res
}

function ok(res) {
    global.response = res
}

function log(x) {
    if (global.debug) console.log(x)
}

function apiToken(x) {
    console.log(x)
}

function okOpen(res){
    global.response = res 
    // console.log(e)
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}

// 暴露
export {
    monitor,
    transfer,
    bind,
    ping,
    ok,
    log,
    uuidv4,
    apiToken,
    okOpen
}